<template>
  <div class="hpPage">
      <div class="--py-3xl el-size--large pro-page">        
        
        <div class="--py-3xl">
          <div style="border:solid 0px red;padding-top:0px;min-height:800px;">            
            
            <section class="hpSection __fixed">
              <hp-logo></hp-logo>
            </section>

            <section class="hpSection __fixed">
              <hp-herovideo v-if="pageLayoutData.sections"></hp-herovideo> -->
            </section>

<!--             <section class="hpSection">
              <hp-text></hp-text>
            </section>
 -->            
            <section class="hpSection" id="section_products">
              <hp-products :sectionData = "hpProductsData"></hp-products>
            </section>
 
            <section class="hpSection" id="section_webinars">
              <hp-webinars :sectionData = "hpWebinarsData"></hp-webinars>
            </section>

            <section class="hpSection" id="section_cases">
              <hp-cases :sectionData = "hpCasesData"></hp-cases>
            </section>

            <section class="hpSection" id="section_protips">
              <hp-protips :sectionData = "hpProTipsData"></hp-protips>
            </section>

            <section class="hpSection" id="section_blog">
              <hp-collage :sectionData = "hpBlogData"></hp-collage>
            </section>

            <section class="hpSection">
              <hp-contact></hp-contact>
            </section>

          </div>
        </div>      
      </div>
  </div>
</template>







<script>
    import { splitLines } from "@/utils";
    import { mapState, mapActions, mapGetters } from "vuex";
    //import hpText from './home/hpText2.vue';
    import hpText from './home/hpText3.vue';
    import hpProducts from './home/hpProducts.vue';
    import hpWebinars from "./home/hpWebinars.vue";
    import hpProtips from './home/hpProtips';
    import hpCollage from './home/hpCollage';
    import hpLogo from './home/hpLogo';
    import hpContact from './home/hpContact';
    import hpCases from './home/hpCases';
    import hpHero from './home/hpHero';

    //import hpHerocollage from './home/hpHeroCollage';
    import hpHerovideo from './home/hpHeroVideo';

    export default {
    components: { hpLogo,hpHero,hpHerovideo,hpText,hpWebinars, hpProtips,hpCollage,hpProducts ,hpContact,hpCases},
        data() 
        {
            return {
              items:null
            };
        },
        created()
        {
          this.setPageReady(false);
          this.initScrollListener();
          //this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);
        },
        async mounted()
        {            
          //alert("loading data");
            this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);
            //this.initPageData();
            //this.resetPageLayout();
            //this.setPageReady(true);
        },
        computed: {
          //...mapGetters(["catalogCategories"]),
          ...mapState(["product_data", "pageReady","pageLayoutData"]),
          pageTitle() {
            return this.pageLayoutData &&
              this.pageLayoutData.meta &&
              this.pageLayoutData.meta.page_title
              ? this.pageLayoutData.meta.page_title
              : "MIS - Dental Implants Technology";
          },
          pageDescription() {
            return this.pageLayoutData &&
              this.pageLayoutData.meta &&
              this.pageLayoutData.meta.meta_description
              ? this.pageLayoutData.meta.meta_description
              : "MIS - Dental Implants Technology";
          },
          pageKeywords() {
            return this.pageLayoutData &&
              this.pageLayoutData.meta &&
              this.pageLayoutData.meta.meta_keywords
              ? this.pageLayoutData.meta.meta_keywords
              : "MIS, dental implants, c1, v3";
          },              
          hpProductsData()
          {
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'products'
              );
              return typeSection[0];
          },
          hpWebinarsData()
          {
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'webinars'
              );
              return typeSection[0];
          },
          hpCasesData()
          {
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'clinical-cases'
              );
              return typeSection[0];            
          },
          hpProTipsData()
          {
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'protips'
              );
              return typeSection[0];
          },
          hpBlogData()
          {
              const typeSection = this.pageLayoutData.sections.filter( x => 
                x.type == 'blog'
              );
              return typeSection[0];
          },

          getPrductUserURL()
          {
            //return 'https://www.misimplants.qarad.eifu.online/mis/def/?keycode='+this.product_item_data.product.CatalogNo;
          }
        },
        methods: {
            ...mapActions(["initHomepageData","resetPageLayout", "setPageReady","initRouteByPath","setItemToCollect","addItemToCollection"]),            
            updateMeta()
            {
              //Force the header title to update
              const titleEl = document.querySelector('head title');
              titleEl.textContent = this.pageTitle;
              document.querySelector('meta[name="description"]').setAttribute("content", this.pageDescription);
              document.querySelector('meta[name="keywords"]').setAttribute("content", this.pageKeywords);
            },
            initText()
            {
              var splitBlocks = document.getElementsByClassName('split-text');
              for (var i = 0; i < splitBlocks.length; i++) 
              {
                let originalElement = splitBlocks[i];
                //extract the additional class names from the original element
                //and inject them into the splitted rows
                var injectClasses = originalElement.className;
                injectClasses = injectClasses.replace("split-text", "");

                splitLines(originalElement,injectClasses); 
              }
            },
            async initPageData2()
            {                
              //var hpPath = `HomeV3/${this.$route.params.locale || "global"}`;
              //this.initHomepageData(hpPath);
              //mutation: SET_HP_CONTENT
              this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);

                //let content = await this.initRouteByPath(this.$route.path);
                //this.product_item_data = content;
            },
            getLinksListTitle()
            {
                return this.localize("learn_more");
            },      
            getImageURL()
            {
              return 'https://www.mis-implants.com/upload/catalog/products/large/'+
                      this.cProData.product.CatalogNo+'.png';
            },
            __initPageData()
            {
              //BYPASS THE UTILS AND LOAD THE DATA FROM SERVER 
              ////////////////////////////////////////////////////////////////////////
              ////////////////////////////////////////////////////////////////////////
              ////////////////////////////////////////////////////////////////////////
              let vm = this;
              var name = `HomeV3/${this.$route.params.locale || "global"}`;      
              let body = JSON.stringify({ name });
              let apiHeaders = { "Content-Type": "application/json" };
              let apiOptions = { body, method: "post" };
              fetch(api, options).then(function(response) 
              {
                  if (response.status !== 200) {
                    throw new Error("Something Went Wrong!");
                  }
                  return response.json();
                })
                .then(function(json) {  

                });
          },

          ////scroll events /////////////////
          ////scroll events /////////////////
          ////scroll events /////////////////
          initScrollListener(){
            window.addEventListener("scroll", this.scrollHandler, false);      
          },    
          scrollHandler() {
            this.checkSectionsView();
          },
          checkSectionsView(){
            var vm=this;
            var reveals = document.querySelectorAll(".hpSection");
            for (var i = 0; i < reveals.length; i++) 
            {
              var windowHeight = window.innerHeight;
              var elementTop = reveals[i].getBoundingClientRect().top;

              /*  
              if(i==1)
              {
                let heroEl= document.getElementById("homeHeroVideo1");
                let startYpos = reveals[0].getBoundingClientRect().height;
                //check video position
                //console.log("startYpos = "+ startYpos+" elementTop="+elementTop + "  windowHeight="+windowHeight);
                let refY = (elementTop-startYpos)/(windowHeight);
                refY = 100*(refY);
                refY = Math.floor(refY);
                let precY = refY+"%";
                heroEl.style = "--clipVal:"+precY;
                console.log("precY="+precY);
              }*/

              var elementVisible = 350;
              if (elementTop < windowHeight - elementVisible && elementTop>0){
                if(vm.visibleSection != i){
                  vm.visibleSection = i;
                  vm.onSectionVisible(i);
                }
              }
            }
          },
          onSectionVisible(domSectionIndex)
          {
              var vm=this;
              let sectionIndex = domSectionIndex;
              var sectionElement = document.querySelectorAll(".hpSection")[domSectionIndex];
              let sectionDataIndex = sectionIndex;

              if(domSectionIndex>2){          
                //vid.pause();//pause video when hero is hidden
                //when scrolling to section 2 or futher, by defult select the 3.75 platform
              }else{
                //vid.play();//resume video when hero is visible
              }
              this.revealSectionChildrenElements(sectionElement);
          },

          // REAVEL CHILD ELEMENTS 
          revealSectionChildrenElements(parentElement) 
          {
            var vm=this;
            parentElement.classList.add("active");
            var reveals = parentElement.querySelectorAll(".reveal");
            for (var i = 0; i < reveals.length; i++){
                if(reveals[i].classList.contains("active")==false)
                {
                  //vm.onRevealingSection(reveals[i].id);
                  reveals[i].classList.add("active");
                }
            }
          },
          onRevealingSection(sectionID)
          {

          }    
          ////////
        },
        watch: {
            pageLayoutData() 
            {
              var vm =this;
              setTimeout(() => {
                vm.initText();//split the text lines for the reaveling fx
              }, 1000);              
              this.setPageReady(true);
              this.updateMeta();
            },
            locale: {
              deep: true,
              handler() {
                this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);
              }
            },          
/*           '$route' (to, from) {
            this.resetPageLayout();
            this.initPageData();
            this.setPageReady(true);
          }
 */        }

    }
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
  .hpFont1
  {
      font-size:clamp(0.75rem, 0.8vw, 1.5rem) !important;
  }
  .hpFont15
  {
      font-size:clamp(16px, 1.1vw, 30px) !important;
  }
  .hpFont2
  {
      font-size:clamp(1.2rem, 1.4vw, 2.5rem) !important;
  }
  .hpBold
  {
    font-weight:500 !important;
  }
  .hpSection
  {
    height: auto;
  }
  
/*   //test
  .hpSection:nth-child(2)
  {
    transition: all ease 0.4s;
  }
  .hpSection:nth-child(2).active
  {
    background-color: #000;
  }
 */


  .hpPage
  {
    clear: both;
    /* perspective: 1px; */
    /* background-color: #111; */
  }
  .hpSecTitle
  {
    font-size: 40px;
    letter-spacing: -1.5px !important;
    color: #414141;
    text-transform: uppercase;
    display: block;
    margin: auto;
    text-align: center;
  }
  .hpSecSub
  {
    display: block;
    margin: auto;
    text-align: center;
    width: 100%;
  }
  .hpSecSub a
  {
    font-size: 13px;
    color: #444444;
    text-transform: uppercase;
    margin: auto;
    cursor: pointer;
    transition: all ease 0.3s;
    font-weight: 300 !important;
  }
  .hpSecSub a span
  {
    font-weight: 500 !important;
    position: relative;
  }  
  .hpSecSub a span::after
  {
    content: "";
    height: 2px;
    position:absolute;
    width: 100%;
    border-bottom: solid 1px #1894e2;
    bottom: -5px;
    left: 0px;
    transform: scaleX(0%);
    transition: all ease 0.3s;
  }
  .hpSecSub a:hover span::after
  {
    transform: scaleX(100%);
  }
  .hpSecSub a:hover span
  {
    color: #1894e2;
  }


  .hpPage section
  {
    clear: both;
  }
  .hpSection.fixed
  {
    top: 0px;
    left: 0px;
    position: fixed;
    width: 100vw;
    height: 100vh;
    margin-bottom: 100vh;
  }
  
  /* ----------- mobile ----------- */
  @media screen and (max-width: 815px) {
    .hpSecTitle
    {
      font-size: 30px;
    }
  }


</style>
